import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../../../../services/hmi-lookup.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'makine-tanimi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mt-edit">
      <div class="mt-baslik">
        <div class="mt-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
          </svg>
        </div>
        <span>Makine Tanımı</span>
      </div>

      <div class="mt-form">
        <div class="form-grup">
          <label>Makine Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.makineAdi || ''"
              (ngModelChange)="guncelle('makineAdi', $event)"
              placeholder="Makine adını girin..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup f1">
            <label>Makine Kodu</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.makineKodu || ''"
                (ngModelChange)="guncelle('makineKodu', $event)"
                placeholder="CNC-001"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup f1">
            <label>Tip</label>
            <div class="input-wrap">
              <nz-select
                [ngModel]="p()?.tip"
                (ngModelChange)="guncelle('tip', $event)"
                nzPlaceHolder="Tip seçin..."
                nzAllowClear
                style="width:100%"
                [nzCustomTemplate]="tipTpl">
                @for (t of tipler; track t.ad) {
                  <nz-option [nzValue]="t.ad" [nzLabel]="t.ad" nzCustomContent>
                    <div class="sel-item"><span class="sel-dot" [style.background]="t.renk"></span><span class="sel-ad">{{ t.ad }}</span></div>
                  </nz-option>
                }
              </nz-select>
              <ng-template #tipTpl let-selected>
                <span class="sel-item"><span class="sel-dot" [style.background]="tipRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
              </ng-template>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="mt-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup f1">
            <label>Marka</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.marka || ''"
                (ngModelChange)="guncelle('marka', $event)"
                placeholder="Marka"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup f1">
            <label>Model</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.model || ''"
                (ngModelChange)="guncelle('model', $event)"
                placeholder="Model"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-grup">
          <label>Seri No</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.seriNo || ''"
              (ngModelChange)="guncelle('seriNo', $event)"
              placeholder="Seri numarası"/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="mt-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup f1">
            <label>Departman</label>
            <div class="input-wrap">
              <nz-select
                [ngModel]="p()?.departman"
                (ngModelChange)="guncelle('departman', $event)"
                nzPlaceHolder="Departman seçin..."
                nzAllowClear nzShowSearch nzServerSearch
                (nzOnSearch)="lookup.departmanlariYukle($event)"
                (nzOpenChange)="$event && lookup.departmanlariYukle()"
                style="width:100%"
                [nzCustomTemplate]="mtDeptTpl">
                @for (d of lookup.departmanlar(); track d._id) {
                  <nz-option [nzValue]="d.ad" [nzLabel]="d.ad" nzCustomContent>
                    <div class="sel-item"><span class="sel-emoji">🏢</span><div class="sel-bilgi"><span class="sel-ad">{{ d.ad }}</span>@if (d.kod) { <span class="sel-detay">{{ d.kod }}</span> }</div></div>
                  </nz-option>
                }
              </nz-select>
              <ng-template #mtDeptTpl let-selected>
                <span class="sel-item"><span class="sel-emoji">🏢</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
              </ng-template>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup f1">
            <label>Konum</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.konum || ''"
                (ngModelChange)="guncelle('konum', $event)"
                placeholder="A Hol, B Hol..."/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="mt-ayirici"></div>

        <div class="form-grup">
          <label>Durum</label>
          <div class="durum-secici">
            @for (d of durumlar; track d.deger) {
              <button class="durum-btn"
                [class.secili]="p()?.durum === d.deger"
                [style.--_d]="d.renk"
                (click)="guncelle('durum', d.deger)">
                <span class="durum-dot"></span>
                {{ d.deger }}
              </button>
            }
          </div>
        </div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.notlar || ''"
              (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Makine ile ilgili notlar..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .mt-edit { display: flex; flex-direction: column; gap: 0; padding: 0; }

    .mt-baslik {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; margin-bottom: 4px; border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .mt-baslik-ikon {
      width: 32px; height: 32px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #92400e, #f59e0b);
      color: #fff; flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(245, 158, 11, 0.35);
      position: relative;
    }

    .mt-baslik-ikon::after {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%; animation: shimmer 3s infinite linear; pointer-events: none;
    }

    .mt-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }

    .mt-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }

    .mt-ayirici {
      height: 1px; opacity: 0.4; margin: 2px 0;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
    }

    .form-satir { display: flex; gap: 12px; }
    .f1 { flex: 1; }

    .form-grup { display: flex; flex-direction: column; gap: 5px; }

    .form-grup label {
      font-size: 11px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); transition: color 0.2s ease;
    }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }

    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px;
      background: linear-gradient(90deg, #92400e, #f59e0b, #92400e);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0; pointer-events: none; z-index: 1;
    }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }

    .input-wrap input[nz-input],
    .input-wrap textarea[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px;
      padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }
    .input-wrap input[nz-input]:hover,
    .input-wrap textarea[nz-input]:hover { border-color: var(--py-kenarlik-hover, #b3b3b3); background: var(--py-arkaplan-hover, #f5f5f5); }
    .input-wrap input[nz-input]:focus,
    .input-wrap textarea[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1); outline: none; }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important;
      border-radius: 8px !important; min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }
    .input-wrap:hover ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; background: var(--py-arkaplan-hover, #f5f5f5) !important; }
    .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; background: var(--py-input-arka, #fff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    .durum-secici { display: flex; gap: 8px; flex-wrap: wrap; }
    .durum-btn {
      --_d: #22c55e;
      flex: 1; min-width: 80px; display: flex; align-items: center; justify-content: center; gap: 6px;
      padding: 8px 12px; border-radius: 8px; border: 1px solid var(--py-kenarlik, #d9d9d9);
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      font-size: 11px; font-weight: 500; color: var(--py-metin-ikincil, rgba(0,0,0,0.65));
      cursor: pointer; transition: all 0.25s ease; white-space: nowrap;
    }
    .durum-btn:hover { border-color: var(--_d); color: var(--_d); }
    .durum-btn.secili {
      border-color: var(--_d); color: var(--_d);
      background: color-mix(in srgb, var(--_d) 8%, transparent);
      box-shadow: 0 0 0 2px color-mix(in srgb, var(--_d) 12%, transparent);
    }
    .durum-dot {
      width: 8px; height: 8px; border-radius: 50%; background: var(--_d);
      box-shadow: 0 0 6px var(--_d);
    }

    @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
  `],
})
export class MakineTanimiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);

  constructor() { super(); this.lookup.departmanlariYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  tipler = [
    { ad: 'CNC', renk: '#3b82f6' },
    { ad: 'Torna', renk: '#8b5cf6' },
    { ad: 'Freze', renk: '#06b6d4' },
    { ad: 'Taşlama', renk: '#f59e0b' },
    { ad: 'Pres', renk: '#ef4444' },
    { ad: 'Kaynak', renk: '#f97316' },
    { ad: 'Kesim', renk: '#10b981' },
    { ad: 'Diğer', renk: '#6b7280' },
  ];

  tipRenk(v: string): string {
    return this.tipler.find(t => t.ad === v)?.renk || '#6b7280';
  }

  durumlar = [
    { deger: 'Aktif', renk: '#22c55e' },
    { deger: 'Bakımda', renk: '#f59e0b' },
    { deger: 'Arızalı', renk: '#ef4444' },
    { deger: 'Devre Dışı', renk: '#6b7280' },
  ];

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }
}
